import React from 'react';

import {SliderBlock, GridColumnSize} from '@yandex-data-ui/page-constructor';
import {NavigationSectionType, List, Category} from 'units/navigation/models';
import {FEATURED} from 'units/services/constants';
import RecommendedIcon from 'components/RecommendedIcon/RecommendedIcon';
import NavigationCardItem from 'units/navigation/components/NavigationCardItem/NavigationCardItem';

type ListMFeaturedProps = List & Category;

const ListMFeatured: React.FC<ListMFeaturedProps> = ({
    category,
    navigationItems,
    type = NavigationSectionType.Services,
}) => {
    const {name, description} = category;

    return (
        <SliderBlock
            title={{
                text: name,
                textSize: 's',
                custom: <RecommendedIcon />,
            }}
            description={description ?? undefined}
            animated={false}
            slidesToShow={{
                [GridColumnSize.Xl]: 3,
                [GridColumnSize.Lg]: 2,
            }}
            anchorId={FEATURED}
        >
            {navigationItems.map((item) => (
                <NavigationCardItem item={item} key={item.slug} type={type} />
            ))}
        </SliderBlock>
    );
};

export default ListMFeatured;
